import has from 'lodash/has';
import * as types from '../../constants/actionTypes';
import { authFetch } from '../../api';
import { removeEntities } from '../entities';

const request = () => ({
	type: types.ADMIN_NOTIFICATION_DELETE_REQUEST,
});

const success = (message = '') => ({
	type: types.ADMIN_NOTIFICATION_DELETE_SUCCESS,
	payload: {
		message,
	},
});

const failure = (message = 'Something went wrong.') => ({
	type: types.ADMIN_NOTIFICATION_DELETE_FAILURE,
	payload: {
		message,
	},
});

export default function remove(id, history) {
	return (dispatch, getState) => {
		const state = getState();
		const { token } = state.auth;

		dispatch(request());

		return authFetch(
			`admin-notifications/${id}`,
			{
				method: 'delete',
			},
			token,
			dispatch,
		)
			.then(res => res.json())
			.then(res => {
				if (!has(res, 'removed'))
					return has(res, 'error')
						? dispatch(failure(res.error))
						: dispatch(failure('Something went wrong.'));

				dispatch(success(res.message || null));
				dispatch(removeEntities('adminNotifications', id));
				return history.push('/admin-notifications');
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/deleteAdminNotification.js